import {Injectable} from "@angular/core";
import {User} from "../model/user";
import {Headers, RequestOptions} from "@angular/http";
import {CookieService, CookieOptionsArgs} from "angular2-cookie/core";
import {Subject} from "rxjs/Rx";
import {Router} from "@angular/router";
import {BusinessRight} from "../model/business-right";

@Injectable()
export class AuthentService {
    private user:User;
    private token:string;
    private right:BusinessRight;
    redirectUrl:string;

    private loggedInSource = new Subject<boolean>();

    loggedIn$ = this.loggedInSource.asObservable();

    private rightSource = new Subject<BusinessRight>();

    userRight$ = this.rightSource.asObservable();

    opts: CookieOptionsArgs = {
        expires: new Date('2030-01-01')
    };

    constructor(private cookie:CookieService, private router:Router) {
        let token = cookie.get('us_t');
        let user = cookie.get('us_u');

        if (token != null) {
            this.token = token;
        }

        if (user != null) {
            this.user = JSON.parse(user);
        }
    }

    logout():void {
        this.cookie.removeAll();
        this.token = null;
        this.user = null;
        this.right = null;
        this.loggedInSource.next(false);
        this.rightSource.next(null);

        this.router.navigateByUrl('/');
    }

    getAnonymousHeaders():RequestOptions {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Basic ZmFtaWxpZXNhcHA6b3VyZmFtaWx5c2VjcmV0'
        });
        return new RequestOptions({headers: headers});
    }

    getAuthentHeaders():RequestOptions {
        let headers = new Headers({
            'Authorization': 'Bearer ' + this.getToken()
        });
        return new RequestOptions({headers: headers});
    }

    getJSONAuthentHeaders():RequestOptions {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.getToken()
        });
        return new RequestOptions({headers: headers});
    }

    getJSONHeaders():RequestOptions {
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        return new RequestOptions({headers: headers});
    }

    getToken():string {

        if (this.token == null && this.cookie.get('us_t') == null) {
            return null;
        }

        return this.token;
    }

    setToken(token:string):void {
        this.token = token;
        this.cookie.put('us_t', token, this.opts);
    }

    getUser():User {
        return this.user;
    }

    setUser(user:User):void {
        this.user = user;
        this.cookie.put('us_u', JSON.stringify(user), this.opts);

        this.loggedInSource.next(true);
    }

    setRight(right:BusinessRight) {
        this.right = right;

        this.rightSource.next(right);
    }

    getRight() {
        return this.right;
    }

    isLogged():boolean {
        if (this.getToken() != null) {
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/authent.service.ts